module.exports = __webpack_public_path__ + "static/media/sf-trial-correct.f1de9530.mp3";